<template>
    <div class="timeOff">
        <el-card class="boxCard">
            <div slot="header" class="clearfix">
                <span>{{ activeItem?.name || '设备' }}</span>
            </div>
            <div class="content">
                <div>关闭时间<el-time-picker style="margin-left: 20px;" v-model="timeValue" placeholder="请选择关闭时间" format="HH:mm"
                        value-format="HH:mm" :picker-options="{ format: 'HH:mm' }">
                    </el-time-picker></div>
                <div><el-button round type="primary" @click="confirm()">提交</el-button></div>
            </div>
        </el-card>
    </div>
</template>

<script>
import api from "@/api";
export default {
    name: "TimeOff",
    props: {
        activeItem: {
            type: Object,
            default: () => { },
        },
    },
    components: {},
    data() {
        return {
            timeValue: '',
        }
    },
    computed: {},
    methods: {
        async getData() {
            // this.$store.commit("SET_LOADING", true);
            let res = await api.DMGetTimeOff({
                keys: "CloseTime",
            }, this.activeItem?.id?.id || this.activeItem?.deviceId);
            if (res?.status == 200) {
                // this.timeValue = value
                const newvalue = res?.data?.[0]?.value
                console.log(newvalue);
                this.timeValue = newvalue
            }
            this.$store.commit("SET_LOADING", false);
        },
        async confirm() {
            let res = await api.DMSetTimeOff({
                key: "CloseTime",
                deviceId: this.activeItem?.id?.id || this.activeItem?.deviceId,
                value: this.timeValue
            });
            if (res?.data?.code == 200) {
                this.$message.success('操作成功')
            }
            this.$store.commit("SET_LOADING", false);
        }
    },
    created() {
        this.getData()
    },
    mounted() {
    },
}
</script> 

<style lang="scss" scoped>
.timeOff {
    width: 100%;
    height: 100%;
    @include setFlexCenter;

    .boxCard {
        width: 90%;
        height: 90%;

        .content {
            @include setFlexBetween;
        }
    }
}
</style>